import { temAcesso } from '@/shared/auth/temAcesso'

const Comprometimentos = () => import('./Comprometimentos2.vue')
// const Pagamento = () => import('./Pagamento.vue')
// const PagamentoAssociarComprometimentos = () =>
//     import('./PagamentoAssociarComprometimentos.vue')

export default {
    path: 'servicos',
    name: 'Contratos_Comprometimentos',
    component: Comprometimentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-COMPR-10')) {
            next()
        }
    }
    // ,
    // children: [
    //     {
    //         path: ':pagamentoId',
    //         name: 'Contratos_Pagamentos_Detalhar',
    //         component: Pagamento,
    //         beforeEnter: (to, from, next) => {
    //             if (temAcesso('CONT-PAG-02')) {
    //                 next()
    //             }
    //         },
    //         children: [
    //             {
    //                 path: 'associarservicos',
    //                 name: 'Contratos_Pagamentos_AssociarComprometimentos',
    //                 component: PagamentoAssociarComprometimentos,
    //                 beforeEnter: (to, from, next) => {
    //                     if (temAcesso('CONT-PAG-04')) {
    //                         next()
    //                     }
    //                 }
    //             }
    //         ]
    //     }
    // ]
}
